
export async function fetchLeaderboard({ organizationId, sessionId, userId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/fetchSessionReport`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ organizationId, sessionId, userId }),
  });
  if (!resp.ok) {
    const { message } = await resp.json();
    throw new Error(message || 'Failed to fetch leaderboard');
  }
  return resp.json();
}
